var _polygon, _path, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 100",
    width: 100,
    x: "0px",
    y: "0px",
    fill: "black",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "112all") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "49.87 18.19 41.87 18.19 41.87 42.15 26.5 42.15 26.5 50.15 49.87 50.15 49.87 18.19"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.64,52.76A43.85,43.85,0,0,0,45.42,1.58a43.84,43.84,0,1,0,7.33,87.06A25.56,25.56,0,1,0,88.64,52.76ZM45.42,81.26A35.84,35.84,0,1,1,81.26,45.42c0,1.08-.06,2.16-.16,3.23A25.56,25.56,0,0,0,48.65,81.1C47.58,81.2,46.5,81.26,45.42,81.26Zm27.42,9.16A17.57,17.57,0,1,1,90.42,72.85,17.59,17.59,0,0,1,72.85,90.42Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 68.85,
    y: 59.97,
    width: 8,
    height: 18.75
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 68.85,
    y: 80.97,
    width: 8,
    height: 5.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpired);
export default __webpack_public_path__ + "static/media/expired.da5e2a54dab448941a25e8ab2eb0a368.svg";
export { ForwardRef as ReactComponent };